import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TemplateComponent } from './template/template.component';
import { title } from 'process';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss'],
  // imports: [TemplateComponent],
  standalone: false,
})
export class FacilitiesComponent implements OnInit {
  activeTab: string = 'Facilities';
  @Input() school: any = {};
  displayedFacilities: any[] = [];
  displayedActivities: any[] = [];
  displayedInfrastructure: any[] = [];
  //
  isBrowser: boolean;

  facilitiesData = [
    {
      title: 'Smart Classes',
      key: 'isSmartClass',
      description:
        'Empowering students with digital tools for a dynamic and engaging education.',
      icon: '../../assets/images/screen.png',
      item: `<svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 11.1875H20.875V13.8125H23.5V11.1875Z" fill="#FFC402"/>
<path d="M27.875 11.1875H25.25V13.8125H27.875V11.1875Z" fill="#FFC402"/>
<path d="M19.125 11.1875H16.5V13.8125H19.125V11.1875Z" fill="#FFC402"/>
<path d="M14.75 11.1875H12.125V13.8125H14.75V11.1875Z" fill="#FFC402"/>
<path d="M35.75 0.25H4.25C2.325 0.25 0.75 1.825 0.75 3.75V21.25C0.75 23.175 2.325 24.75 4.25 24.75H35.75C37.675 24.75 39.25 23.175 39.25 21.25V3.75C39.25 1.825 37.675 0.25 35.75 0.25ZM6 21.25H4.25V3.75H6V21.25ZM30.5 21.25H9.5V3.75H30.5V21.25ZM35.75 21.25H34V3.75H35.75V21.25Z" fill="#FFC402"/>
</svg>`,
      color: '#0045b0',
    },
    {
      title: 'CCTV',
      key: 'isCctv',
      description:
        'Encouraging physical activity and teamwork with well-equipped outdoor facilities.',
      icon: '../../assets/images/play-ground.png',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#0045b0',
    },
    {
      title: 'School Wifi',
      key: 'isWifi',
      description:
        'High-speed internet to support learning, research, and collaboration.',
      icon: '../../assets/images/wifi.png',
      item: `<svg width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.0174 33.17L41.3699 7.8125C40.5824 7.2175 32.7424 0.8125 20.9999 0.8125C9.23988 0.8125 1.41738 7.2175 0.629883 7.8125L20.9824 33.17L20.9999 33.1875L21.0174 33.17Z" fill="#FFC402"/>
</svg>
`,
      color: '#0045b0',
    },
    {
      title: 'Hospital',
      key: 'isHospital',
      description:
        'Encouraging physical activity and teamwork with well-equipped outdoor facilities.',
      icon: '../../assets/images/bus.png',
      item: `<svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 0.375C6.265 0.375 0 1.25 0 7.375V24.875C0 26.415 0.6825 27.7975 1.75 28.76V31.875C1.75 32.8375 2.5375 33.625 3.5 33.625H5.25C6.2125 33.625 7 32.8375 7 31.875V30.125H21V31.875C21 32.8375 21.7875 33.625 22.75 33.625H24.5C25.4625 33.625 26.25 32.8375 26.25 31.875V28.76C27.3175 27.7975 28 26.415 28 24.875V7.375C28 1.25 21.735 0.375 14 0.375ZM23.905 5.6075H4.095C5.0575 4.68 7.5425 3.875 14 3.875C20.4575 3.875 22.9425 4.68 23.905 5.6075ZM24.5 9.1075V14.375H3.5V9.1075H24.5ZM23.905 26.1525L23.3975 26.625H4.6025L4.095 26.1525C3.8675 25.96 3.5 25.5225 3.5 24.875V17.875H24.5V24.875C24.5 25.5225 24.1325 25.96 23.905 26.1525Z" fill="#FFC402"/>
<path d="M7.875 24.875C9.32475 24.875 10.5 23.6997 10.5 22.25C10.5 20.8003 9.32475 19.625 7.875 19.625C6.42525 19.625 5.25 20.8003 5.25 22.25C5.25 23.6997 6.42525 24.875 7.875 24.875Z" fill="#FFC402"/>
<path d="M20.125 24.875C21.5747 24.875 22.75 23.6997 22.75 22.25C22.75 20.8003 21.5747 19.625 20.125 19.625C18.6753 19.625 17.5 20.8003 17.5 22.25C17.5 23.6997 18.6753 24.875 20.125 24.875Z" fill="#FFC402"/>
</svg>
`,
      color: '#0045b0',
    },
    {
      title: 'Hostel',
      key: 'isHostel',
      description:
        'Encouraging physical activity and teamwork with well-equipped outdoor facilities.',
      icon: '../../assets/images/play-ground.png',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#0045b0',
    },
    {
      title: 'School Transport',
      key: 'isTransport',
      description:
        'Ensuring on-time and secure commutes with well-maintained buses and tracking systems.',
      icon: '../../assets/images/bus.png',
      item: `<svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 0.375C6.265 0.375 0 1.25 0 7.375V24.875C0 26.415 0.6825 27.7975 1.75 28.76V31.875C1.75 32.8375 2.5375 33.625 3.5 33.625H5.25C6.2125 33.625 7 32.8375 7 31.875V30.125H21V31.875C21 32.8375 21.7875 33.625 22.75 33.625H24.5C25.4625 33.625 26.25 32.8375 26.25 31.875V28.76C27.3175 27.7975 28 26.415 28 24.875V7.375C28 1.25 21.735 0.375 14 0.375ZM23.905 5.6075H4.095C5.0575 4.68 7.5425 3.875 14 3.875C20.4575 3.875 22.9425 4.68 23.905 5.6075ZM24.5 9.1075V14.375H3.5V9.1075H24.5ZM23.905 26.1525L23.3975 26.625H4.6025L4.095 26.1525C3.8675 25.96 3.5 25.5225 3.5 24.875V17.875H24.5V24.875C24.5 25.5225 24.1325 25.96 23.905 26.1525Z" fill="#FFC402"/>
<path d="M7.875 24.875C9.32475 24.875 10.5 23.6997 10.5 22.25C10.5 20.8003 9.32475 19.625 7.875 19.625C6.42525 19.625 5.25 20.8003 5.25 22.25C5.25 23.6997 6.42525 24.875 7.875 24.875Z" fill="#FFC402"/>
<path d="M20.125 24.875C21.5747 24.875 22.75 23.6997 22.75 22.25C22.75 20.8003 21.5747 19.625 20.125 19.625C18.6753 19.625 17.5 20.8003 17.5 22.25C17.5 23.6997 18.6753 24.875 20.125 24.875Z" fill="#FFC402"/>
</svg>
`,
      color: '#0045b0',
    },
  ];

  activitiesData = [
    {
      title: 'Art & Craft',
      key: 'isArtAndCraft',
      description:
        'Inspiring imagination and skill development with diverse art and craft activities.',
      icon: '../../assets/images/mobile.svg',
      item: `<svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 11.1875H20.875V13.8125H23.5V11.1875Z" fill="#FFC402"/>
<path d="M27.875 11.1875H25.25V13.8125H27.875V11.1875Z" fill="#FFC402"/>
<path d="M19.125 11.1875H16.5V13.8125H19.125V11.1875Z" fill="#FFC402"/>
<path d="M14.75 11.1875H12.125V13.8125H14.75V11.1875Z" fill="#FFC402"/>
<path d="M35.75 0.25H4.25C2.325 0.25 0.75 1.825 0.75 3.75V21.25C0.75 23.175 2.325 24.75 4.25 24.75H35.75C37.675 24.75 39.25 23.175 39.25 21.25V3.75C39.25 1.825 37.675 0.25 35.75 0.25ZM6 21.25H4.25V3.75H6V21.25ZM30.5 21.25H9.5V3.75H30.5V21.25ZM35.75 21.25H34V3.75H35.75V21.25Z" fill="#FFC402"/>
</svg>`,
      color: '#e2800b',
    },
    {
      title: 'Gardening',
      key: 'isGardening',
      description:
        'Teaching sustainability and responsibility through engaging gardening experiences.',
      icon: '../../assets/images/truck.svg',
      item: `<svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 0.375C6.265 0.375 0 1.25 0 7.375V24.875C0 26.415 0.6825 27.7975 1.75 28.76V31.875C1.75 32.8375 2.5375 33.625 3.5 33.625H5.25C6.2125 33.625 7 32.8375 7 31.875V30.125H21V31.875C21 32.8375 21.7875 33.625 22.75 33.625H24.5C25.4625 33.625 26.25 32.8375 26.25 31.875V28.76C27.3175 27.7975 28 26.415 28 24.875V7.375C28 1.25 21.735 0.375 14 0.375ZM23.905 5.6075H4.095C5.0575 4.68 7.5425 3.875 14 3.875C20.4575 3.875 22.9425 4.68 23.905 5.6075ZM24.5 9.1075V14.375H3.5V9.1075H24.5ZM23.905 26.1525L23.3975 26.625H4.6025L4.095 26.1525C3.8675 25.96 3.5 25.5225 3.5 24.875V17.875H24.5V24.875C24.5 25.5225 24.1325 25.96 23.905 26.1525Z" fill="#FFC402"/>
<path d="M7.875 24.875C9.32475 24.875 10.5 23.6997 10.5 22.25C10.5 20.8003 9.32475 19.625 7.875 19.625C6.42525 19.625 5.25 20.8003 5.25 22.25C5.25 23.6997 6.42525 24.875 7.875 24.875Z" fill="#FFC402"/>
<path d="M20.125 24.875C21.5747 24.875 22.75 23.6997 22.75 22.25C22.75 20.8003 21.5747 19.625 20.125 19.625C18.6753 19.625 17.5 20.8003 17.5 22.25C17.5 23.6997 18.6753 24.875 20.125 24.875Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
    {
      title: 'Student Led Activities',
      key: 'isStudentLedEvents',
      description:
        'Fostering leadership, teamwork, and innovation through student-initiated programs.',
      icon: '../../assets/images/sector.svg',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
    {
      title: 'Drama',
      key: 'isDrama',
      description:
        'Developing creativity, expression, and teamwork through theatrical performances.',
      icon: '../../assets/images/ground.svg',
      item: `<svg width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.0174 33.17L41.3699 7.8125C40.5824 7.2175 32.7424 0.8125 20.9999 0.8125C9.23988 0.8125 1.41738 7.2175 0.629883 7.8125L20.9824 33.17L20.9999 33.1875L21.0174 33.17Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
    {
      title: 'Dance',
      key: 'isDance',
      description:
        'Encouraging creativity, fitness, and self-expression through rhythm and graceful movements.',
      icon: '../../assets/images/ground.svg',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
    {
      title: 'Yoga',
      key: 'isYoga',
      description:
        'Promoting mental and physical health with guided yoga sessions.',
      icon: '../../assets/images/ground.svg',
      item: `<svg width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.0174 33.17L41.3699 7.8125C40.5824 7.2175 32.7424 0.8125 20.9999 0.8125C9.23988 0.8125 1.41738 7.2175 0.629883 7.8125L20.9824 33.17L20.9999 33.1875L21.0174 33.17Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
    {
      title: 'Picnic',
      key: 'isPicnic',
      description:
        'Providing students with fun-filled outdoor experiences to foster teamwork, relaxation, and a love for nature.',
      icon: '../../assets/images/truck.svg',
      item: `<svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 0.375C6.265 0.375 0 1.25 0 7.375V24.875C0 26.415 0.6825 27.7975 1.75 28.76V31.875C1.75 32.8375 2.5375 33.625 3.5 33.625H5.25C6.2125 33.625 7 32.8375 7 31.875V30.125H21V31.875C21 32.8375 21.7875 33.625 22.75 33.625H24.5C25.4625 33.625 26.25 32.8375 26.25 31.875V28.76C27.3175 27.7975 28 26.415 28 24.875V7.375C28 1.25 21.735 0.375 14 0.375ZM23.905 5.6075H4.095C5.0575 4.68 7.5425 3.875 14 3.875C20.4575 3.875 22.9425 4.68 23.905 5.6075ZM24.5 9.1075V14.375H3.5V9.1075H24.5ZM23.905 26.1525L23.3975 26.625H4.6025L4.095 26.1525C3.8675 25.96 3.5 25.5225 3.5 24.875V17.875H24.5V24.875C24.5 25.5225 24.1325 25.96 23.905 26.1525Z" fill="#FFC402"/>
<path d="M7.875 24.875C9.32475 24.875 10.5 23.6997 10.5 22.25C10.5 20.8003 9.32475 19.625 7.875 19.625C6.42525 19.625 5.25 20.8003 5.25 22.25C5.25 23.6997 6.42525 24.875 7.875 24.875Z" fill="#FFC402"/>
<path d="M20.125 24.875C21.5747 24.875 22.75 23.6997 22.75 22.25C22.75 20.8003 21.5747 19.625 20.125 19.625C18.6753 19.625 17.5 20.8003 17.5 22.25C17.5 23.6997 18.6753 24.875 20.125 24.875Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
    {
      title: 'Debate',
      key: 'isDebate',
      description:
        'Sharpening analytical and communication skills through structured debates.',
      icon: '../../assets/images/mobile.svg',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#e2800b',
    },
  ];

  infrastructureData = [
    {
      title: 'Music Room',
      key: 'isMusicRoom',
      description:
        'Our special educators provide personalized support to students with unique learning needs, fostering an inclusive environment.',
      icon: '../../assets/images/icon2.svg',
      item: `<svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 11.1875H20.875V13.8125H23.5V11.1875Z" fill="#FFC402"/>
<path d="M27.875 11.1875H25.25V13.8125H27.875V11.1875Z" fill="#FFC402"/>
<path d="M19.125 11.1875H16.5V13.8125H19.125V11.1875Z" fill="#FFC402"/>
<path d="M14.75 11.1875H12.125V13.8125H14.75V11.1875Z" fill="#FFC402"/>
<path d="M35.75 0.25H4.25C2.325 0.25 0.75 1.825 0.75 3.75V21.25C0.75 23.175 2.325 24.75 4.25 24.75H35.75C37.675 24.75 39.25 23.175 39.25 21.25V3.75C39.25 1.825 37.675 0.25 35.75 0.25ZM6 21.25H4.25V3.75H6V21.25ZM30.5 21.25H9.5V3.75H30.5V21.25ZM35.75 21.25H34V3.75H35.75V21.25Z" fill="#FFC402"/>
</svg>`,
      color: '#7360bd',
    },
    {
      title: 'Library',
      key: 'isLibrary',
      description:
        'Our team of counsellors supports students’ emotional well-being and personal development.',
      icon: '../../assets/images/icon1.svg',
      item: `<svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 11.1875H20.875V13.8125H23.5V11.1875Z" fill="#FFC402"/>
<path d="M27.875 11.1875H25.25V13.8125H27.875V11.1875Z" fill="#FFC402"/>
<path d="M19.125 11.1875H16.5V13.8125H19.125V11.1875Z" fill="#FFC402"/>
<path d="M14.75 11.1875H12.125V13.8125H14.75V11.1875Z" fill="#FFC402"/>
<path d="M35.75 0.25H4.25C2.325 0.25 0.75 1.825 0.75 3.75V21.25C0.75 23.175 2.325 24.75 4.25 24.75H35.75C37.675 24.75 39.25 23.175 39.25 21.25V3.75C39.25 1.825 37.675 0.25 35.75 0.25ZM6 21.25H4.25V3.75H6V21.25ZM30.5 21.25H9.5V3.75H30.5V21.25ZM35.75 21.25H34V3.75H35.75V21.25Z" fill="#FFC402"/>
</svg>`,
      color: '#7360bd',
    },
    {
      title: 'Science Labs',
      key: 'isScienceLab',
      description:
        'Our special educators provide personalized support to students with unique learning needs, fostering an inclusive environment.',
      icon: '../../assets/images/icon4.svg',
      item: `<svg width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.0174 33.17L41.3699 7.8125C40.5824 7.2175 32.7424 0.8125 20.9999 0.8125C9.23988 0.8125 1.41738 7.2175 0.629883 7.8125L20.9824 33.17L20.9999 33.1875L21.0174 33.17Z" fill="#FFC402"/>
</svg>
`,
      color: '#7360bd',
    },
    {
      title: 'Computer Lab',
      key: 'isComputerLab',
      description:
        'With over 50 dedicated teachers, we offer expert instruction across a wide range of subjects.',
      icon: '../../assets/images/icon3.svg',
      item: `<svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 11.1875H20.875V13.8125H23.5V11.1875Z" fill="#FFC402"/>
<path d="M27.875 11.1875H25.25V13.8125H27.875V11.1875Z" fill="#FFC402"/>
<path d="M19.125 11.1875H16.5V13.8125H19.125V11.1875Z" fill="#FFC402"/>
<path d="M14.75 11.1875H12.125V13.8125H14.75V11.1875Z" fill="#FFC402"/>
<path d="M35.75 0.25H4.25C2.325 0.25 0.75 1.825 0.75 3.75V21.25C0.75 23.175 2.325 24.75 4.25 24.75H35.75C37.675 24.75 39.25 23.175 39.25 21.25V3.75C39.25 1.825 37.675 0.25 35.75 0.25ZM6 21.25H4.25V3.75H6V21.25ZM30.5 21.25H9.5V3.75H30.5V21.25ZM35.75 21.25H34V3.75H35.75V21.25Z" fill="#FFC402"/>
</svg>`,
      color: '#7360bd',
    },
    {
      title: 'Swimming Pool',
      key: 'isSwimmingPool',
      description:
        'Our special educators provide personalized support to students with unique learning needs, fostering an inclusive environment.',
      icon: '../../assets/images/icon2.svg',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#7360bd',
    },
    {
      title: 'Playground',
      key: 'isPlayground',
      description:
        'Encouraging physical activity and teamwork with well-equipped outdoor facilities.',
      icon: '../../assets/images/icon1.svg',
      item: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM6.1525 10.5625C7.675 12.085 8.725 14.045 9.0925 16.25H4.1225C4.385 14.185 5.1025 12.26 6.1525 10.5625ZM4.1225 19.75H9.0925C8.725 21.955 7.675 23.915 6.1525 25.4375C5.1025 23.74 4.385 21.815 4.1225 19.75ZM16.25 31.8775C13.2225 31.4925 10.4925 30.1275 8.3925 28.1325C10.6675 25.9625 12.225 23.04 12.6275 19.75H16.25V31.8775ZM16.25 16.25H12.6275C12.2075 12.96 10.6675 10.02 8.375 7.85C10.4925 5.855 13.2225 4.5075 16.25 4.1225V16.25ZM31.8775 16.25H26.9075C27.275 14.045 28.325 12.085 29.8475 10.5625C30.8975 12.26 31.615 14.185 31.8775 16.25ZM19.75 4.1225C22.7775 4.5075 25.5075 5.855 27.625 7.85C25.3325 10.02 23.7925 12.96 23.3725 16.25H19.75V4.1225ZM19.75 31.8775V19.75H23.3725C23.7925 23.04 25.3325 25.9625 27.6075 28.1325C25.5075 30.1275 22.7775 31.4925 19.75 31.8775ZM29.8475 25.4375C28.325 23.9325 27.2925 21.955 26.9075 19.75H31.8775C31.615 21.815 30.8975 23.74 29.8475 25.4375Z" fill="#FFC402"/>
</svg>
`,
      color: '#7360bd',
    },
  ];

  //
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.filterFacilities();
    this.filterActivities();
    this.filterInfrastructure();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      this.filterFacilities();
      this.filterActivities();
      this.filterInfrastructure();
    }
  }

  filterFacilities(): void {
    const facilities = this.school.facilities || {};
    this.displayedFacilities = this.facilitiesData.filter(
      (facility) =>
        facilities[facility.key] === true || this.school[facility.key] === true
    );
  }
  filterActivities(): void {
    const activities = this.school.activities || {};
    this.displayedActivities = this.activitiesData.filter((activity) => {
      return activities[activity.key] === true;
    });
  }

  filterInfrastructure(): void {
    const infrastructure = this.school.infrastructure || {};
    this.displayedInfrastructure = this.infrastructureData.filter((infra) => {
      return infrastructure[infra.key] === true;
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  scrollToSection(sectionId: string) {
    if (this.isBrowser) {
      const section = document.getElementById(sectionId);
      if (section) {
        const offsetTop = section.offsetTop;
        window.scrollTo({
          top: offsetTop - 120,
          behavior: 'smooth',
        });
      }
    }
  }
}
